import React from 'react';
import './css/Footer.scss';

const Footer = () => {
  return (
    <div className="col-xs-12 SweetescapePro__Footer">
      <div className="col-xs-12 SweetescapePro__Footer__Text">
        © 2020 SweetEscape. All Right Reserved
      </div>
    </div>
  )
}

export default Footer;